<template>
  <!-- cene u marketima na pocetnoj: logika klizaca je u ScrollSlider -->
  <ScrollSlider
    :items="productsList"
    :title="title"
    item-class="swiper-product-width"
    :btn-prev-class="['swiper-button-prev-tc-most', btn_prev]"
    :btn-next-class="['swiper-button-next-tc-most', btn_next]"
    icon-class="font-icon-module"
    :dots-class="['mt-5 swiper-pagination-most', paginate]"
  >
    <template #item="{ item }">
      <MarketPriceDisplay :product="item" />
    </template>
  </ScrollSlider>
</template>

<script setup>
import ScrollSlider from '~/components/widgets/Slider/ScrollSlider.vue'
import MarketPriceDisplay from './MarketPriceDisplay.vue'

const props = defineProps({
  products: { type: Array, default: () => [] },

  from: { type: Number, default: 0 },
  to: { type: Number, default: 0 },
  type: { type: String, default: '' },
  title: { type: String, default: '' },

  paginate: { type: String, default: 'swiper-pagination' },
  btn_next: { type: String, default: 'swiper-button-next' },
  btn_prev: { type: String, default: 'swiper-button-prev' },
})

const productsList = computed(() => {
  const arr = Array.isArray(props.products) ? props.products : []
  if (props.to && props.to > 0) return arr.slice(props.from, props.to)
  return arr
})
</script>
